<template>
    <AppHead title="Meine Daten" />
    <div class="lg:px-64">
        <PageTitle>Meine Daten</PageTitle>
        <div class="w-full lg:flex items-start lg:space-x-8">
            <div class="w-full lg:w-1/2">
                <ValidationErrors class="mb-4" />
                <form @submit.prevent="submit">
                    <div class="mt-4">
                        <FormLabel for="company" value="Veranstalter/Firma * (komplette Rechtsform)" />
                        <FormInput id="company" type="text" class="mt-1 block w-full" v-model="form.company" required autofocus autocomplete="organization" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="name" value="Name Ansprechpartner * (Titel/Vorname/Nachname)" />
                        <FormInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autocomplete="name" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="address" value="Straße/Hausnummer *" />
                        <FormInput id="address" type="text" class="mt-1 block w-full" v-model="form.address" required autocomplete="street-address" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="zip" value="PLZ *" />
                        <FormInput id="zip" type="text" class="mt-1 block w-full" v-model="form.zip" required autocomplete="postal-code" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="city" value="Ort *" />
                        <FormInput id="city" type="text" class="mt-1 block w-full" v-model="form.city" required autocomplete="address-level2" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="internet" value="Internet" />
                        <FormInput id="internet" type="url" class="mt-1 block w-full" v-model="form.internet" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="phone" value="Telefon" />
                        <FormInput id="phone" type="text" class="mt-1 block w-full" v-model="form.phone" autocomplete="tel-national" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="email" value="E-Mail *" />
                        <FormInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="username" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="password" value="Passwort" />
                        <FormInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" autocomplete="new-password" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="password_confirmation" value="Passwort wiederholen" />
                        <FormInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" autocomplete="new-password" />
                    </div>
                    <div class="flex items-center justify-end mt-4">
                        <div v-if="form.recentlySuccessful" class="text-sm text-green-600">
                            Gespeichert
                        </div>
                        <FormButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            Änderungen speichern
                        </FormButton>
                    </div>
                </form>
            </div>
            <div class="w-full mt-4 lg:w-1/2 lg:mt-0">
                <p>
                    Hier können Sie Ihre Daten einsehen und bearbeiten.<br>
                    Bestätigen Sie bitte alle Änderungen über den Button „Änderungen speichern“
                </p>
            </div>
        </div>
    </div>
</template>
<script setup>
import {useForm} from "@inertiajs/vue3";
import AppHead from '@/Shared/Head'
import PageTitle from '@/Shared/Page/Title'
import ValidationErrors from '@/Shared/Form/ValidationErrors';
import FormLabel from '@/Shared/Form/Label';
import FormInput from '@/Shared/Form/Input';
import FormButton from '@/Shared/Form/Button';

const props = defineProps({
    manager: Object
})
const form = useForm({
    company: props.manager.company,
    name: props.manager.name,
    address: props.manager.address,
    zip: props.manager.zip,
    city: props.manager.city,
    internet: props.manager.internet,
    phone: props.manager.phone,
    email: props.manager.email,
    password: null,
    password_confirmation: null,
})
const submit = () => {
    form.put(route('manager.data.update'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
        preserveScroll: true
    });
};
</script>
